module.exports = __webpack_public_path__ + "static/img/banner-certificate-1.b910603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-certificate-1.png
// module id = gkin
// module chunks = 1